import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, NavLink } from "react-router-dom";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-[#000000] text-white py-4 fixed top-0 left-0 right-0 z-50 shadow-lg">
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
            <img 
              src="/Final_logo_6.png" 
              alt="Moreflex Aviation" 
              className="h-12 mr-2"
              loading="lazy"
            />
          </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            About Us
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            Services
          </NavLink>
          <NavLink
            to="/partners"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            Partners
          </NavLink>
          <NavLink
            to="/resources"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            Resources
          </NavLink>
          <NavLink
            to="/faq"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            FAQ
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "text-[#73BDF2] font-bold transition-colors duration-300" : "hover:text-[#73BDF2] transition-colors duration-300"
            }
          >
            Contact Us
          </NavLink>
        </nav>

        {/* Desktop Button */}
        <Link to="/contact" className="hidden md:block bg-[#73BDF2] text-white px-4 py-2 rounded hover:bg-[#5ba8e0] transition-colors duration-300">
          Let's Talk
        </Link>

        {/* Mobile Menu Button (ALWAYS VISIBLE ON SMALL SCREENS) */}
        <button className="md:hidden block text-white" onClick={toggleMenu}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#111] p-4 animate-fadeIn">
          <nav className="flex flex-col space-y-4">
            <Link to="/" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              Home
            </Link>
            <Link to="/about" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              About Us
            </Link>
            <Link to="/services" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              Services
            </Link>
            <Link to="/partners" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              Partners
            </Link>
            <Link to="/resources" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              Resources
            </Link>
            <Link to="/faq" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              FAQ
            </Link>
            <Link to="/contact" className="text-white hover:text-[#73BDF2] transition-colors duration-300" onClick={toggleMenu}>
              Contact Us
            </Link>
            <Link to="/contact" className="bg-[#73BDF2] text-white px-4 py-2 rounded hover:bg-[#5ba8e0] transition-colors duration-300 w-full text-center" onClick={toggleMenu}>
              Let's Talk
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
